import { render, staticRenderFns } from "./PortcallinvoicesGrid.vue?vue&type=template&id=4f83f6dd"
import script from "./PortcallinvoicesGrid.vue?vue&type=script&lang=js"
export * from "./PortcallinvoicesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports